import {
  customerDetailsAtom,
  selectedAppointmentAsyncAtom,
  selectedDeviceTypeAsyncAtom,
  selectedRepairsAsyncAtom,
  selectedStoreAsyncAtom,
  store,
  storeIdAtom,
} from '@service-initiation/tech-care-data-access-store';

export const buildExtraDataForLog = async () => {
  const selectedRepairs = await store.get(selectedRepairsAsyncAtom);
  const deviceType = await store.get(selectedDeviceTypeAsyncAtom);
  const customerDetails = store.get(customerDetailsAtom);

  const appointment = await store.get(selectedAppointmentAsyncAtom);
  const appointmentIntentId = appointment?.intentId;
  const appointmentDate = appointment?.date;
  const appointmentStartTime = appointment?.startTime;
  const selectedStore = await store.get(selectedStoreAsyncAtom);
  const storeId = store.get(storeIdAtom);

  return {
    data: {
      appointmentInfo: {
        selectedAppointmentDate: appointmentDate,
        selectedAppointmentTime: appointmentStartTime,
        storeTimezone: selectedStore?.time_zone,
      },
      customerDetails: {
        isEmail: !!customerDetails?.email,
        isFirstName: !!customerDetails?.firstName,
        isLastName: !!customerDetails?.lastName,
        isPhoneNumber: !!customerDetails?.phoneNumber,
      },
      deviceRepairId: selectedRepairs?.[0]?.id,
      deviceTypeId: deviceType?.id,
      intentId: appointmentIntentId,
      storeId,
    },
  };
};
